import { createSlice } from '@reduxjs/toolkit';
import {
  createEventTicket,
  getEventTickets
} from '../views/EventPromo/Event.actions';

import {
  EventTickets,
  UserTickets,
  UserEventTicketModel
} from '../views/EventPromo/Event.types';

export interface EventTicketSliceType {
  loading: boolean;
  eventTicketLoader: boolean;
  eventTickets: EventTickets[] | any;
  userTickets: UserTickets | any;
  eventOrder: UserEventTicketModel | null;
}

const initialState = {
  loading: false,
  eventTicketLoader: false,
  eventTickets: [],
  userTickets: null,
  eventOrder: null
} as EventTicketSliceType;

const eventTicketsSlice = createSlice({
  name: 'eventTickets',
  initialState,
  reducers: {
    // changeAvailableBalance(state, { payload }) {
    //   if (state.info) {
    //     state.info.totalEarnings.availableBalance =
    //       state.info.totalEarnings.availableBalance - payload;
    //   }
    // }
  },

  extraReducers: (builder) => {
    builder.addCase(getEventTickets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getEventTickets.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.eventTickets = payload.eventTickets;
      state.userTickets = payload.userTickets;
    });

    builder.addCase(getEventTickets.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createEventTicket.pending, (state) => {
      state.eventTicketLoader = true;
    });
    builder.addCase(createEventTicket.fulfilled, (state, { payload }) => {
      state.eventTicketLoader = false;
      if (payload) {
        state.eventOrder = payload.eventTicket;
        state.userTickets.availableRewardPoints =
          state.userTickets.availableRewardPoints -
          Number(payload.eventTicket.price);
      }
    });

    builder.addCase(createEventTicket.rejected, (state) => {
      state.eventTicketLoader = false;
    });
  }
});

export default eventTicketsSlice.reducer;
